import type { IStoreAdminPort } from '@onboarding/application/ports';
import type { StoreAdminInfo } from '@onboarding/domain/value-objects';
import { createStoreAdminInfo } from '@onboarding/domain/value-objects';
import type { OnboardingHttpClientType } from '@onboarding/infrastructure/api';

/**
 * Concrete implementation of IStoreAdminPort.
 *
 * Fetches the admin snapshot from the backend and reconstructs the StoreAdminInfo
 * value object via the domain factory — never builds the entity manually.
 */
export const createStoreAdminRepository = (props: { httpClient: OnboardingHttpClientType }): IStoreAdminPort => {
  const { httpClient } = props;

  const getStoreAdminInfo = async (): Promise<StoreAdminInfo> => {
    const response = await httpClient.getStoreAdminInfo();

    return createStoreAdminInfo({
      storeName: response.storeDetails.storeName,
      legalName: response.payProcessorAffiliation.businessName,
      rfc: response.payProcessorAffiliation.rfc,
      street: response.payProcessorAffiliation.street,
      extNumber: response.payProcessorAffiliation.extNumber,
      neighborhood: response.payProcessorAffiliation.neighborhood,
      zipCode: response.payProcessorAffiliation.zipCode,
      city: response.payProcessorAffiliation.city,
      state: response.payProcessorAffiliation.state,
    });
  };

  return { getStoreAdminInfo };
};
